import { classNames } from '@/helpers/common';
import React from 'react';
import logoFullWhite from '../../assets/images/logo-full-white.png';
import logo from '../../assets/images/logo.svg';

export const SimplePaymentHeader: React.FC = () => (
  <header className={classNames('w-full shadow-xs')}>
    <div className="container mx-auto h-28 flex justify-between items-center">
      <div className="flex flex-1 items-center sm:items-stretch sm:justify-start">
        <div className="flex flex-shrink-0 items-center">
          <a href="#">
            <span className="sr-only">Banca do Ingresso</span>
            <img className="block w-auto lg:hidden" src={logo} alt="Banca do Ingresso" />
            <img
              className="w-auto h-[80px] hidden lg:block"
              src={logoFullWhite}
              alt="Banca do Ingresso"
            />
          </a>
        </div>
      </div>
    </div>
  </header>
);
